export const ErrorType = {
  USER_BASED: "userBased",
  SERVICE_BASED: "serviceBased",
};
